//LIBRERIE
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    const carouselItems = [
        "/assets/images/altrePag/aboutUsCarousel/c0.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c1.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c2.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c3.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c4.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c5.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c6.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c7.jpg",
        "/assets/images/altrePag/aboutUsCarousel/c8.jpg",
    ]

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };

    return (
        <>
            <div className="col-12 col-lg-8">
                <h2>{t('aboutUsPage.title')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }}></p>
                <p className="mb-2">{t('aboutUsPage.para6')}</p>
                <ul className="pl-4">
                    <li dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem1') as string }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem2') as string }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem3') as string }}></li>
                </ul>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para7') as string }}></p>
            </div>
            <div className="col-12 col-sm-10 col-md-8 col-lg-4 text-center">
                <div className="position-relative">
                    <Carousel activeIndex={index} onSelect={handleSelect} controls={false} indicators={false} fade={true} interval={6000} pause={false}>
                        {carouselItems.map((item, idx) => (
                            <Carousel.Item key={idx}>
                                <img className="img-fluid" src={item} alt={`Lucca ${idx + 1}`} />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    <p className="mb-0 carousel-text">{t('aboutUsPage.carouselCaption')}</p>
                </div>
            </div>
            <div className="col-12 mt-4">
                <div className="row align-items-center agent-card-about-us">
                    <div className="col-12 col-lg-4 text-center">
                        <img className="img-fluid mb-3 mb-lg-0" src="/assets/images/altrePag/paolo.jpg" alt="Paolo" />
                    </div>
                    <div className="col-12 col-lg-8">
                        <div className="d-flex flex-wrap">
                            <h3 className="mr-3">Paolo Venuti</h3>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.paolo.para1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.paolo.para2') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.paolo.para3') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.paolo.para4') as string }}></p>
                    </div>
                </div>
                <div className="row align-items-center agent-card-about-us">
                    <div className="col-12 col-lg-4 text-center">
                        <img className="img-fluid mb-3 mb-lg-0" src="/assets/images/altrePag/alessia.jpg" alt="Alessia" />
                    </div>
                    <div className="col-12 col-lg-8">
                        <div className="d-flex flex-wrap">
                            <h3 className="mr-3">Alessia Malossi</h3>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.alessia.para1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.alessia.para2') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.alessia.para3') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.alessia.para4') as string }}></p>
                    </div>
                </div>
            </div>
        </>
    )
};
export default AboutUsMain;